export type PaginationItem = number | "ellipsis-left" | "ellipsis-right";

/** Abbreviated list: full when ≤7, otherwise keeps edge/current windows. */
export function buildPageList(
  current: number,
  total: number
): PaginationItem[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  const items: PaginationItem[] = [];
  if (current <= 4) {
    for (let page = 1; page <= 5; page++) items.push(page);
    items.push("ellipsis-right", total);
  } else if (current >= total - 3) {
    items.push(1, "ellipsis-left");
    for (let page = total - 4; page <= total; page++) items.push(page);
  } else {
    items.push(1, "ellipsis-left");
    for (let page = current - 1; page <= current + 1; page++) {
      items.push(page);
    }
    items.push("ellipsis-right", total);
  }

  return items;
}
